export default "__VITE_ASSET__tpJv0FZ3__"